async function sha256(value) {
  const encoder = new TextEncoder();
  const data = encoder.encode(value);
  const hashBuffer = await crypto.subtle.digest("SHA-256", data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  return hashArray.map(b => b.toString(16).padStart(2, "0")).join("");
}

export async function hashString(txt) {
  if (!txt) return null;
  const normalized = txt.trim().toLowerCase();
  return await sha256(normalized);
}

export async function hashPhone(phone) {
  if (!phone) return null;
  let digits = phone.replace(/\D/g, "");
  if (digits.length === 10) {
    digits = "1" + digits;
  }
  return await sha256(digits);
}